import { DatePicker, Drawer, message } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
  createLeaveRequest,
  fetchLeaveRequestByEmployeeId,
  updateLeaveRequest,
} from "../../../../core/data/redux/attendance/leave/leaveAction";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../core/data/redux/store";
import { fetchAllLeaveTypes } from "../../../../core/data/redux/attendance/leaveTypes/LeaveTypeActions";
import { filterByStatus } from "../../../../core/utils/filterActiveData";

const selectLevaeChoose = [
  { value: "Full Day", label: "Full Day" },
  { value: "Half Day", label: "Half Day" },
];

const LeaveRequestModal: React.FC<any> = ({
  modalType,
  isModalVisible,
  handleCancel,
  employeeId,
  setTableKey,
  leaveRequestId,
  selectedRowData,
  employeeassignleave,
  checkWeeklyOffRange
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { leaveTypes } = useSelector((state: any) => state.attendance.leaveTypes);
  const { leaveRequests, loadingStates } = useSelector((state: any) => state.attendance.leaveRequests);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;

  const LeaveTypesData = leaveTypes ? leaveTypes : [];
  const [errors, setErrors] = useState<any>({});
  const [leaveRequestData, setLeaveRequestData] = useState({
    selectedLeaveType: "",
    LeaveMode: "",
    fromDate: null as dayjs.Dayjs | null,
    toDate: null as dayjs.Dayjs | null,
    reason: "",
    noOfDays: 0,
    remainingDays: 0,
    file: null,
    fileName: null
  });
  console.log(leaveRequestData.file , leaveRequestData.fileName, 'file');

  const activeLeaveType = filterByStatus(LeaveTypesData, 'active', 'Status');

  useEffect(() => {
    if (!leaveTypes.length) {
      dispatch(fetchAllLeaveTypes());
    }
  }, [dispatch, leaveTypes.length, modalType]);

  useEffect(() => {
    if (modalType === "edit" && leaveRequestId && selectedRowData) {
      setLeaveRequestData({
        selectedLeaveType: selectedRowData.LeaveTypeId || "",
        LeaveMode: selectedRowData.LeaveMode || "",
        fromDate: selectedRowData.FromDate
          ? dayjs(selectedRowData.FromDate)
          : null,
        toDate: selectedRowData.ToDate ? dayjs(selectedRowData.ToDate) : null,
        reason: selectedRowData.Description || "",
        noOfDays: selectedRowData.Duration || 0,
        remainingDays: Number(leaveRequestData?.remainingDays),
        file: null,
        fileName: selectedRowData.AttachmentFileName
      });
    }
    setErrors({});
  }, [leaveRequestId, modalType, selectedRowData]);




  // calculate noOfDays and remainingDays
  useEffect(() => {
    const { fromDate, toDate, selectedLeaveType, LeaveMode } = leaveRequestData;

    if (!selectedLeaveType || !fromDate || !toDate) return;

    const selectedLeave = employeeassignleave.find(
      (item: any) => String(item.LeaveTypeId) === String(selectedLeaveType)
    );

    if (!selectedLeave) return;

    const from = dayjs(fromDate);
    const to = dayjs(toDate);

    if (to.isBefore(from)) return;


    let days = to.diff(from, "day") + 1;
    if (LeaveMode === "Half Day") {
      days = days * 0.5;
    }

    const remaining = Math.max(selectedLeave.LeaveQuantity - days, 0);

    setLeaveRequestData((prev) => ({
      ...prev,
      noOfDays: days,
      remainingDays: remaining,
    }));
  }, [
    leaveRequestData.fromDate,
    leaveRequestData.toDate,
    leaveRequestData.selectedLeaveType,
    leaveRequestData.LeaveMode,
    employeeassignleave,
  ]);




  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  // handle input changes
  // const handleInputChange = (e: any, field: string) => {
  //   const value = e.target.value;
  //   setLeaveRequestData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };


  const handleInputChange = (e: any, field: string) => {
    if (field === "file") {
      const selectedFile = e.target.files[0];
      console.log({ selectedFile })

      if (selectedFile) {
        const allowedTypes = [
          "application/pdf",
          "image/png",
          "image/jpg",
          "image/jpeg",
          "application/msword", // .doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        ];

        if (!allowedTypes.includes(selectedFile.type)) {
          message.warning("Allowed formats: PNG, JPG, JPEG, PDF, DOC, DOCX");
          return;
        }
      }

      setLeaveRequestData((prev) => ({
        ...prev,
        file: selectedFile,
      }));
    } else {
      setLeaveRequestData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };



  // handle date changes
  const handleDateChange = (date: dayjs.Dayjs | null, field: "fromDate" | "toDate") => {
    setLeaveRequestData((prev) => ({
      ...prev,
      [field]: date,
    }));
  };

  const resetForm = () => {
    setLeaveRequestData({
      selectedLeaveType: "",
      LeaveMode: "",
      fromDate: null,
      toDate: null,
      reason: "",
      noOfDays: 0,
      remainingDays: 0,
      file: null,
      fileName: null
    });
    setErrors({});
  };

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      selectedLeaveType: "",
      LeaveMode: "",
      fromDate: "",
      toDate: "",
      reason: "",
      noOfDays: "",
    };

    if (!leaveRequestData.selectedLeaveType) {
      formIsValid = false;
      newErrors.selectedLeaveType = "Please select a leave type.";
    }

    if (!leaveRequestData.LeaveMode) {
      formIsValid = false;
      newErrors.LeaveMode = "Please select a leave.";
    }

    if (!leaveRequestData.fromDate) {
      formIsValid = false;
      newErrors.fromDate = "From date is required.";
    }

    if (!leaveRequestData.toDate) {
      formIsValid = false;
      newErrors.toDate = "To date is required.";
    }

    if (
      leaveRequestData.fromDate &&
      leaveRequestData.toDate &&
      leaveRequestData.fromDate.isAfter(leaveRequestData.toDate)
    ) {
      formIsValid = false;
      newErrors.toDate = "To date cannot be earlier than from date.";
    }

    if (!leaveRequestData.reason.trim()) {
      formIsValid = false;
      newErrors.reason = "Reason is required.";
    }

    if (!leaveRequestData.noOfDays || leaveRequestData.noOfDays <= 0) {
      formIsValid = false;
      newErrors.noOfDays = "Number of days must be greater than 0.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    const { fromDate, toDate } = leaveRequestData;

    if (fromDate && toDate) {
      const { isInvalid, type } = checkWeeklyOffRange(fromDate, toDate);

      if (isInvalid) {
        if (type === "WeeklyOff") {
          message.warning("Your selected date range includes a weekly off. You cannot apply leave on weekly off days.");
        } else if (type === "Holiday") {
          message.warning("Your selected date range includes a holiday. You cannot apply leave on holidays.");
        }
        return;
      }
    }


    if (!validateForm()) return;

    const LeaveRequestData = {
      LeaveTypeId: Number(leaveRequestData.selectedLeaveType),
      FromDate: leaveRequestData.fromDate
        ? leaveRequestData.fromDate.toISOString()
        : "",
      ToDate: leaveRequestData.toDate
        ? leaveRequestData.toDate.toISOString()
        : "",
      Reason: leaveRequestData.reason,
      LeaveMode: leaveRequestData.LeaveMode,
      Duration: leaveRequestData.noOfDays,
      Description: leaveRequestData.reason,
      CreatedBy: user?.UserId,
      ModifiedBy: user?.UserId,
      EmployeeId: employeeId,
      LeaveRequestStatus: "Pending",
      leaveDocument: leaveRequestData.file
    };


    if (modalType === "create") {
      const result = await dispatch(createLeaveRequest(LeaveRequestData));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Leave request created successfully");
        resetForm();
        await dispatch(fetchLeaveRequestByEmployeeId(employeeId));
        if (typeof setTableKey === "function") {
          setTableKey((prevKey: any) => prevKey + 1);
        }
      } else if (result.meta.requestStatus === "rejected") {
        message.error(result.payload.error);
      }
    } else if (modalType === "edit" && leaveRequestId) {
      const result = await dispatch(
        updateLeaveRequest({ leaveRequestId, data: LeaveRequestData })
      );
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Leave request updated successfully");
        await dispatch(fetchLeaveRequestByEmployeeId(employeeId));
        if (typeof setTableKey === "function") {
          setTableKey((prevKey: any) => prevKey + 1);
        }
        resetForm();
      } else if (result.meta.requestStatus === "rejected") {
        message.error(result.payload.error);
      }
    }
    handleCancel();
  };
  return (
    <Drawer
      title={modalType === "edit" ? "Edit leave" : "Add leave"}
      placement="right"
      width={650}
      onClose={() => {
        resetForm();
        handleCancel();
      }}
      visible={isModalVisible}
      style={{ marginTop: 50, paddingBottom: 50 }}
    >

      {employeeassignleave?.length > 0 && (
        <div className="mb-4" style={{ marginTop: "20px" }}>
          <h5 className="fw-bold mb-3">Leave Details</h5>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-sm">
              <thead className="table-light">
                <tr>
                  <th>Leave Type</th>
                  <th>Quantity</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {employeeassignleave?.map((leave: any) => (
                  <tr key={leave.Id}>
                    <td>{leave.LeaveTypeName}</td>
                    <td>{leave.LeaveQuantity}</td>
                    <td>{new Date(leave.Date).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      )}

      <form>
        <div className="modal-body pb-0">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Leave Type <span className="text-danger"> *</span>
                </label>
                <select
                  className="form-control"
                  value={leaveRequestData?.selectedLeaveType}
                  onChange={(e) => handleInputChange(e, "selectedLeaveType")}
                >
                  <option value="">Select Leave Type</option>
                  {employeeassignleave && employeeassignleave?.map((leaveType: any) => (
                    <option key={leaveType.LeaveTypeId} value={leaveType.LeaveTypeId}>
                      {leaveType.LeaveTypeName}
                    </option>
                  ))}
                </select>
                {errors.selectedLeaveType && (
                  <div style={{ color: "red" }}>{errors.selectedLeaveType}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Leave taken <span className="text-danger"> *</span>
                </label>
                <select
                  className="form-control"
                  value={leaveRequestData?.LeaveMode}
                  onChange={(e) => handleInputChange(e, "LeaveMode")}
                >
                  <option value="">Select Leave</option>
                  {selectLevaeChoose?.map((leave: any) => (
                    <option key={leave.value} value={leave.value}>
                      {leave.value}
                    </option>
                  ))}
                </select>
                {errors.LeaveMode && (
                  <div style={{ color: "red" }}>{errors.LeaveMode}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  From <span className="text-danger"> *</span>
                </label>
                <div className="input-icon-end position-relative">
                  <DatePicker
                    className="form-control datetimepicker"
                    format="DD-MM-YYYY"
                    getPopupContainer={getModalContainer}
                    value={
                      leaveRequestData.fromDate
                        ? dayjs(leaveRequestData.fromDate)
                        : null
                    }
                    onChange={(date) => handleDateChange(date, "fromDate")}
                    placeholder="DD-MM-YYYY"
                    disabledDate={(current) => {
                      return current && current < dayjs().startOf("day");
                    }}
                  />

                  <span className="input-icon-addon">
                    <i className="ti ti-calendar text-gray-7" />
                  </span>
                </div>
                {errors.fromDate && (
                  <div style={{ color: "red" }}>{errors.fromDate}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  To <span className="text-danger"> *</span>
                </label>
                <div className="input-icon-end position-relative">
                  <DatePicker
                    className="form-control datetimepicker"
                    format="DD-MM-YYYY"
                    getPopupContainer={getModalContainer}
                    value={
                      leaveRequestData.toDate
                        ? dayjs(leaveRequestData.toDate)
                        : null
                    }
                    onChange={(date) => handleDateChange(date, "toDate")}
                    placeholder="DD-MM-YYYY"
                    disabledDate={(current) => {

                      return current && current < dayjs().startOf("day");
                    }}
                  />

                  <span className="input-icon-addon">
                    <i className="ti ti-calendar text-gray-7" />
                  </span>
                </div>
                {errors.toDate && (
                  <div style={{ color: "red" }}>{errors.toDate}</div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  No of Days <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={leaveRequestData?.noOfDays}
                  onChange={(e) => handleInputChange(e, "noOfDays")}
                  disabled
                />

                {errors.noOfDays && (
                  <div style={{ color: "red" }}>{errors.noOfDays}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Remaining Days <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={leaveRequestData?.remainingDays}
                  disabled
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Upload Document</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".pdf, .png, .jpg, .jpeg, .doc, .docx"
                  onChange={(e) => handleInputChange(e, "file")}
                />
              </div>
              {modalType === "edit" && leaveRequestData.fileName && !leaveRequestData.file && (
                <p className="mt-2">
                  <strong>Uploaded file:</strong> {leaveRequestData.fileName}
                </p>
              )}

            </div>


            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">
                  Reason <span className="text-danger"> *</span>
                </label>
                <textarea
                  className="form-control"
                  rows={2}
                  value={leaveRequestData.reason}
                  onChange={(e) => handleInputChange(e, "reason")}
                />
                {errors.reason && (
                  <div style={{ color: "red" }}>{errors.reason}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light me-2"
            onClick={() => {
              handleCancel();
              setErrors({});
              resetForm();
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit} disabled={isLoading}
          >{isLoading && <span className="spinner-border spinner-border-sm me-2" />}
            {modalType === "edit" ? "Update Leave" : "Add Leave"}
          </button>
        </div>
      </form>



    </Drawer>
  );
};

export default LeaveRequestModal;
